import { default as MuiAvatar } from '@mui/material/Avatar';

export interface AvatarProps { 
    name: string;
}

const Avatar = ({ name }: AvatarProps) => {   
    return (
        <MuiAvatar
            alt=""
            sx={{ bgcolor: "secondary.light" }}
        >
            {name?.charAt(0) || ""}
        </MuiAvatar>
    );
};

export default Avatar;
